import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
import { Edit, Search } from '@element-plus/icons-vue';
import { onMounted, reactive, ref } from "vue";
import dayjs from "dayjs";
import apis from '@/api';
import { ElMessage } from "element-plus";
import NoticeDialog from './components/NoticeDialog';
export default {
  __name: 'NoticeSetting',
  setup(__props) {
    const columns = [{
      label: "公告名称",
      prop: "noticeName"
    }, {
      label: "状态",
      prop: "status",
      formatter: val => {
        if (val === "1") {
          return "在线";
        } else if (val === "0") {
          return "已下线";
        } else {
          return "未知";
        }
      }
    }, {
      label: "公告开始时间",
      prop: "startTime"
    }, {
      label: "公告结束时间",
      prop: "endTime"
    }];
    const data = reactive({
      queryParam: {
        noticeName: '',
        status: '1',
        startTime: '',
        endTime: ''
      },
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      tableData: [],
      currentNotice: {}
    });
    const noticeDialogVisible = ref(false);
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const elLoading = ref(false);
    const dateStartChange = e => {
      if (data.queryParam.startTime) {
        data.queryParam.startTime = dayjs(data.queryParam.startTime).format("YYYY-MM-DD");
        console.info(data.queryParam.startTime);
      }
    };
    const dateEndChange = e => {
      if (data.queryParam.endTime) {
        data.queryParam.endTime = dayjs(data.queryParam.endTime).format("YYYY-MM-DD");
        console.info(data.queryParam.endTime);
      }
    };
    const loadData = () => {
      const params = {
        ...data.queryParam,
        ...data.pagination
      };
      elLoading.value = true;
      apis.listNotice(params).then(res => {
        console.log('listNotice:', res);
        if (res.success) {
          var _res$data;
          const {
            records,
            size,
            total,
            current
          } = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : res.data = {};
          data.tableData = records !== null && records !== void 0 ? records : [];
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error('err');
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    const handleDelete = row => {
      apis.deleteNoticeById({
        id: row.id
      }).then(res => {
        if (res.success) {
          loadData();
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error('err');
      });
    };
    const handleAdd = () => {
      noticeDialogVisible.value = true;
      data.currentNotice = {
        status: '1'
      };
    };
    const handleEdit = row => {
      noticeDialogVisible.value = true;
      data.currentNotice = row;
    };
    onMounted(() => {
      loadData();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_disable = _resolveDirective("disable");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_card, null, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "公告名称",
            prop: "noticeName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.queryParam.noticeName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.queryParam.noticeName = $event),
              size: "small",
              placeholder: "请输入公告名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: data.queryParam.status,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.queryParam.status = $event),
              placeholder: "请选择公告状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "在线",
                value: "1"
              }), _createVNode(_component_el_option, {
                label: "已下线",
                value: "0"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "开始时间",
            prop: "startTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: data.queryParam.startTime,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.queryParam.startTime = $event),
              placeholder: "选择日期",
              onChange: dateStartChange
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "结束时间",
            prop: "endTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: data.queryParam.endTime,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.queryParam.endTime = $event),
              type: "date",
              "value-format": "YYYY-MM-DD HH:MM:SS",
              placeholder: "选择日期",
              onChange: dateEndChange
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: _unref(Search),
              plain: "",
              onClick: loadData
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("查询", -1)]))]),
              _: 1
            }, 8, ["icon"]), _createVNode(_component_el_button, {
              type: "primary",
              icon: _unref(Edit),
              onClick: handleAdd
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("新增", -1)]))]),
              _: 1
            }, 8, ["icon"])]),
            _: 1
          })]),
          _: 1
        }), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: data.tableData,
          style: {
            "width": "100%"
          },
          "header-cell-style": headerStyle.value
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item, index) => {
            return _createVNode(_component_el_table_column, {
              key: index,
              prop: item.prop,
              label: item.label
            }, {
              default: _withCtx(scope => [item.formatter ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.formatter(scope.row[item.prop])), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row[item.prop]), 1))]),
              _: 2
            }, 1032, ["prop", "label"]);
          }), 64)), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "150"
          }, {
            default: _withCtx(scope => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              size: "small",
              onClick: $event => handleEdit(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("编辑 ", -1)]))]),
              _: 1
            }, 8, ["onClick"])), [[_directive_disable, 'notice:edit']]), _withDirectives((_openBlock(), _createBlock(_component_el_popconfirm, {
              "confirm-button-text": "确定",
              "cancel-button-text": "取消",
              icon: "el-icon-info",
              "icon-color": "red",
              title: "要删除该条记录?",
              onConfirm: $event => handleDelete(scope.row)
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                link: "",
                size: "small",
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("删除", -1)]))]),
                _: 1
              })]),
              _: 1
            }, 8, ["onConfirm"])), [[_directive_disable, 'notice:delete']])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "header-cell-style"])), [[_directive_loading, elLoading.value]]), _createVNode(_component_el_pagination, {
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          "page-sizes": [5, 10, 20, 30, 40],
          "page-size": data.pagination.pageSize,
          total: data.pagination.totalSize,
          currentPage: data.pagination.pageNo,
          "onUpdate:currentPage": _cache[4] || (_cache[4] = $event => data.pagination.pageNo = $event),
          layout: "prev, pager, next, sizes, jumper"
        }, null, 8, ["page-size", "total", "currentPage"])]),
        _: 1
      }), _createVNode(_unref(NoticeDialog), {
        notice: data.currentNotice,
        visible: noticeDialogVisible.value,
        "onUpdate:visible": _cache[5] || (_cache[5] = $event => noticeDialogVisible.value = $event),
        onSubmit: loadData
      }, null, 8, ["notice", "visible"])], 64);
    };
  }
};